import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import CommonDashboard from './components/dashboard/CommonDashboard';
import Profile from './components/profile/Profile';
import ChangePassword from './components/dashboard/ChangePassword';
import About from './components/layout/About';
import Contact from './components/layout/Contact';
import PrivacyPolicy from './components/layout/PrivacyPolicy';
import Terms from './components/layout/Terms';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/common/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import MobileNavigation from './components/layout/MobileNavigation';
import AccessVisitTracker from './components/common/AccessVisitTracker';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <Router>
        <AccessVisitTracker />
        <div className="app-shell">
          <Navbar />
          <main className="app-main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute roles={['USER', 'ADMIN', 'SUPER_ADMIN', 'SECURITY']}>
                    <CommonDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute roles={['USER', 'ADMIN', 'SUPER_ADMIN', 'SECURITY']}>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/change-password"
                element={
                  <ProtectedRoute roles={['USER', 'ADMIN', 'SUPER_ADMIN', 'SECURITY']}>
                    <ChangePassword />
                  </ProtectedRoute>
                }
              />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <MobileNavigation />
        </div>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar closeOnClick theme="colored" />
      </Router>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
